
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround3On as ObiGround3OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-3-on.js';
 
 
 

 
 export const ObiGround3On = createComponent({
   react: React,
   tagName: 'obi-ground-3-on',
   elementClass: ObiGround3OnElement,
   events: {
     
   }
  });
 
 